import type { ReactElement } from "react";

import type { TIconProps } from "../types";

export const GoogleCalendar = (props: TIconProps): ReactElement => (
  <svg
    width="23"
    height="22"
    viewBox="0 0 23 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#googlecalendar_clip0_439_72445)">
      <path
        d="M17.2896 5.21046L12.0791 4.63153L5.71063 5.21046L5.13159 11L5.71052 16.7895L11.5 17.5132L17.2896 16.7895L17.8685 10.8553L17.2896 5.21046Z"
        fill="#ffffff"
      />
      <path
        d="M8.08577 14.1929C7.65303 13.9005 7.35339 13.4736 7.18982 12.9091L8.19434 12.4951C8.28553 12.8425 8.4447 13.1117 8.67196 13.3027C8.89779 13.4938 9.17279 13.5879 9.4941 13.5879C9.82267 13.5879 10.1049 13.488 10.3408 13.2882C10.5766 13.0885 10.6954 12.8337 10.6954 12.5255C10.6954 12.21 10.5709 11.9523 10.322 11.7526C10.073 11.553 9.76041 11.453 9.38696 11.453H8.8066V10.4587H9.32756C9.64887 10.4587 9.91958 10.3719 10.1396 10.1982C10.3596 10.0245 10.4696 9.78715 10.4696 9.48465C10.4696 9.21548 10.3711 9.0012 10.1743 8.8406C9.97755 8.68 9.72851 8.59893 9.42601 8.59893C9.13077 8.59893 8.89625 8.67714 8.72256 8.83488C8.54887 8.99262 8.42292 9.18655 8.34339 9.41524L7.3491 9.00131C7.48077 8.62786 7.72255 8.29786 8.07708 8.01274C8.43172 7.72762 8.8847 7.58429 9.4347 7.58429C9.84137 7.58429 10.2076 7.6625 10.5318 7.82024C10.856 7.97798 11.1108 8.19655 11.2946 8.47441C11.4784 8.7537 11.5696 9.06643 11.5696 9.4137C11.5696 9.76834 11.4842 10.0679 11.3134 10.3139C11.1426 10.56 10.9327 10.7481 10.6837 10.8799V10.9392C11.0123 11.0767 11.2801 11.2866 11.4914 11.5688C11.7012 11.8511 11.8068 12.1883 11.8068 12.582C11.8068 12.9757 11.707 13.3274 11.5072 13.6357C11.3074 13.944 11.031 14.1871 10.6808 14.3637C10.3291 14.5402 9.93399 14.63 9.49542 14.63C8.98744 14.6314 8.51851 14.4852 8.08577 14.1929Z"
        fill="hsl(from hsl(217 89% 61%) h s 45%)"
      />
      <path
        d="M14.25 9.20819L13.1529 10.0057L12.6014 9.16914L14.58 7.742H15.3385V14.4737H14.25V9.20819Z"
        fill="hsl(from hsl(217 89% 61%) h s 45%)"
      />
      <path
        d="M17.2896 22L22.5001 16.7895L19.8948 15.6317L17.2896 16.7895L16.1317 19.3948L17.2896 22Z"
        fill="hsl(from hsl(217 89% 61%) h s 50%)"
      />
      <path
        d="M4.55261 19.3948L5.71047 22H17.2894V16.7896H5.71047L4.55261 19.3948Z"
        fill="hsl(from hsl(217 89% 61%) h s 54%)"
      />
      <path
        d="M2.23679 0C1.27726 0 0.5 0.77726 0.5 1.73679V16.7894L3.10524 17.9473L5.71048 16.7894V5.21048H17.2894L18.4473 2.60524L17.2895 0H2.23679Z"
        fill="hsl(from hsl(217 89% 61%) h s 54%)"
      />
      <path
        d="M0.5 16.7896V20.2632C0.5 21.2229 1.27726 22 2.23679 22H5.71048V16.7896H0.5Z"
        fill="hsl(from hsl(217 89% 61%) h s 40%)"
      />
      <path
        d="M17.2896 5.21047V16.7894H22.5V5.21047L19.8948 4.05261L17.2896 5.21047Z"
        fill="hsl(from hsl(217 89% 61%) h s 76%)"
      />
      <path
        d="M22.5 5.21048V1.73679C22.5 0.77715 21.7228 0 20.7632 0H17.2896V5.21048H22.5Z"
        fill="hsl(from hsl(217 89% 61%) h s 46%)"
      />
    </g>
    <defs>
      <clipPath id="googlecalendar_clip0_439_72445">
        <rect
          width="22"
          height="22"
          fill="#ffffff"
          transform="translate(0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);
